var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-app-bar',{attrs:{"color":"primary","dark":"","app":""}},[_vm._v(" Content API ")]),_c('Content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }